import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { FaPlus } from "react-icons/fa";

const IoArrowBack = require("react-icons/io5").IoArrowBack;
const IoClose = require("react-icons/io5").IoClose;

const ProdukDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const token = Cookies.get("token");

  const API = process.env.REACT_APP_API_BASE_URL;

  const [loading, setLoading] = useState(true);

  const [product, setProduct] = useState<any>(null);

  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [stock, setStock] = useState("");
  const [discount, setDiscount] = useState("");
  const [description, setDescription] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [categories, setCategories] = useState<any[]>([]);
  const [sizes, setSizes] = useState<any[]>([]);
  const [colors, setColors] = useState<any[]>([]);
  const [images, setImages] = useState<any[]>([]);

  const [addSizes, setAddSizes] = useState<string[]>([]);
  const [removeSizes, setRemoveSizes] = useState<string[]>([]);

  const [addColors, setAddColors] = useState<string[]>([]);
  const [removeColors, setRemoveColors] = useState<string[]>([]);

  const [sizeInput, setSizeInput] = useState("");
  const [colorInput, setColorInput] = useState("");

  const [newImages, setNewImages] = useState<File[]>([]);
  useEffect(() => {
    fetchProduct();
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${API}/api/categories`);
      setCategories(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchProduct = async () => {
    try {
      const res = await axios.get(`${API}/api/produk/${id}`);

      const data = res.data;

      setProduct(data);

      setName(data.name);
      setPrice(data.price);
      setStock(data.stock);
      setDiscount(data.discount || "");
      setDescription(data.description || "");

      setCategoryId(data.category?.id || "");

      setSizes(data.sizes || []);
      setColors(data.colors || []);
      setImages(data.images || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // ADD SIZE
  const handleAddSize = () => {
    if (!sizeInput) return;

    setSizes([...sizes, sizeInput]); // update preview
    setAddSizes([...addSizes, sizeInput]); // untuk API

    setSizeInput("");
  };

  // REMOVE SIZE
  const handleRemoveSize = (size: string) => {
    setSizes(sizes.filter((s) => s !== size));

    if (!addSizes.includes(size)) {
      setRemoveSizes([...removeSizes, size]);
    }

    setAddSizes(addSizes.filter((s) => s !== size));
  };

  // ADD COLOR
  const handleAddColor = () => {
    if (!colorInput) return;

    setColors([...colors, colorInput]);
    setAddColors([...addColors, colorInput]);

    setColorInput("");
  };

  const handleRemoveColor = (color: string) => {
    setColors(colors.filter((c) => c !== color));

    if (!addColors.includes(color)) {
      setRemoveColors([...removeColors, color]);
    }

    setAddColors(addColors.filter((c) => c !== color));
  };

  // ADD IMAGE
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;

    const files = Array.from(e.target.files);

    setNewImages((prev) => [...prev, ...files]);
  };

  // DELETE IMAGE
  const handleDeleteImage = async (imageId: number) => {
    const confirm = await Swal.fire({
      title: "Hapus gambar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Hapus",
    });

    if (!confirm.isConfirmed) return;

    try {
      await axios.delete(`${API}/api/product-image/${imageId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setImages(images.filter((img) => img.id !== imageId));

      Swal.fire("Berhasil!", "Gambar dihapus", "success");
    } catch {
      Swal.fire("Gagal!", "Tidak bisa hapus gambar", "error");
    }
  };

  // UPDATE PRODUK
  const handleUpdate = async (e: any) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("name", name);
    formData.append("price", price);
    formData.append("stock", stock);
    formData.append("discount", discount);
    formData.append("description", description);
    formData.append("category_id", categoryId);

    addSizes.forEach((s) => formData.append("add_sizes[]", s));
    removeSizes.forEach((s) => formData.append("remove_sizes[]", String(s)));

    addColors.forEach((c) => formData.append("add_colors[]", c));
    removeColors.forEach((c) => formData.append("remove_colors[]", String(c)));

    newImages.forEach((img) => formData.append("images[]", img));

    formData.append("_method", "PUT");

    try {
      await axios.post(`${API}/api/produk/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      await Swal.fire({
        icon: "success",
        title: "Berhasil!",
        text: "Produk berhasil diperbarui",
      });

      navigate("/dashboard/produk");
    } catch (err) {
      console.error(err);

      Swal.fire({
        icon: "error",
        title: "Gagal!",
        text: "Produk gagal diperbarui",
      });
    }
  };

  // DELETE PRODUK
  const handleDeleteProduk = async () => {
    const confirm = await Swal.fire({
      title: "Hapus produk?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Hapus",
    });

    if (!confirm.isConfirmed) return;

    try {
      await axios.delete(`${API}/api/produk/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      await Swal.fire("Berhasil!", "Produk dihapus", "success");

      navigate("/dashboard/produk");
    } catch {
      Swal.fire("Gagal!", "Tidak bisa hapus produk", "error");
    }
  };

  if (loading) return <p></p>;

  return (
    <div className="max-w-4xl mx-auto mt-8 bg-white p-6 rounded-xl shadow">
      <Link to="/dashboard/produk" className="flex items-center gap-2 mb-6">
        <IoArrowBack />
        <h2 className="text-xl font-bold">Edit Produk</h2>
      </Link>

      <form onSubmit={handleUpdate} className="space-y-5">
        {/* NAME */}
        <input className="w-full border p-2" value={name} onChange={(e) => setName(e.target.value)} />

        {/* PRICE */}
        <div>
          <label className="font-semibold">Harga</label>
          <input type="number" className="w-full border p-2 rounded" value={price} onChange={(e) => setPrice(e.target.value)} />
        </div>

        {/* STOCK */}
        <div>
          <label className="font-semibold">Stock</label>
          <input type="number" className="w-full border p-2 rounded" value={stock} onChange={(e) => setStock(e.target.value)} />
        </div>

        {/* DISCOUNT */}
        <div>
          <label className="font-semibold">Diskon (%)</label>
          <input type="number" className="w-full border p-2 rounded" value={discount} onChange={(e) => setDiscount(e.target.value)} />
        </div>

        {/* DESCRIPTION */}
        <div>
          <label className="font-semibold">Deskripsi</label>
          <textarea className="w-full border p-2 rounded" rows={4} value={description} onChange={(e) => setDescription(e.target.value)} />
        </div>

        <div>
          <label className="font-semibold">Kategori</label>

          <select className="w-full border rounded p-2" value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
            <option value="">Pilih Kategori</option>

            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        {/* SIZE */}
        <div>
          <h3>Sizes</h3>

          <div className="flex gap-2">
            <input value={sizeInput} onChange={(e) => setSizeInput(e.target.value)} className="border p-2" />

            <button className="text-white bg-primary p-2 rounded-lg" type="button" onClick={handleAddSize}>
              <FaPlus />
            </button>
          </div>

          <div className="flex gap-2 flex-wrap mt-4">
            {sizes.map((size, i) => (
              <div key={i} className="relative bg-gray-200 px-3 py-1 rounded">
                <button type="button" onClick={() => handleRemoveSize(size)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1">
                  <IoClose />
                </button>

                {size}
              </div>
            ))}
          </div>
        </div>

        {/* COLOR */}
        <div>
          <h3>Colors</h3>

          <div className="flex gap-2">
            <input value={colorInput} onChange={(e) => setColorInput(e.target.value)} className="border p-2" />

            <button className="text-white bg-primary p-2 rounded-lg" type="button" onClick={handleAddColor}>
              <FaPlus />
            </button>
          </div>

          <div className="flex gap-2 flex-wrap mt-4">
            {colors.map((color, i) => (
              <div key={i} className="relative bg-gray-200 px-3 py-1 rounded">
                <button type="button" onClick={() => handleRemoveColor(color)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1">
                  <IoClose />
                </button>

                {color}
              </div>
            ))}
          </div>
        </div>

        {/* IMAGES */}
        <div className="mt-5">
          <input type="file" multiple onChange={handleImageChange} />

          <div className="flex gap-3 mt-3 flex-wrap">
            {/* image lama */}
            {images.map((img: any) => (
              <div key={img.id} className="relative">
                <button type="button" onClick={() => handleDeleteImage(img.id)} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1">
                  <IoClose />
                </button>

                <img src={`${process.env.REACT_APP_STORAGE_URL}/products/${img.image}`} className="w-24 h-24 object-cover rounded" alt="" />
              </div>
            ))}

            {/* preview image baru */}
            {newImages.map((img, i) => (
              <div key={i} className="relative">
                <button type="button" onClick={() => setNewImages(newImages.filter((_, index) => index !== i))} className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1">
                  <IoClose />
                </button>

                <img src={URL.createObjectURL(img)} className="w-24 h-24 object-cover rounded" alt="" />
              </div>
            ))}
          </div>
        </div>

        {/* BUTTON */}
        <div className="flex gap-4">
          <button className="bg-yellow-500 px-4 py-2 rounded">Update Produk</button>

          <button type="button" onClick={handleDeleteProduk} className="bg-red-500 text-white px-4 py-2 rounded">
            Hapus Produk
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProdukDetail;
